import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { memo } from 'react';
import { StyledTab } from './tab.styles';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Router tab element.
 *
 * @author Ihar Kazlouski
 * @function RouterTab
 * @category elements
 * @return {FC} router tab element.
 */
var Tab = /*#__PURE__*/memo(function (_ref) {
  var restProps = _extends({}, _ref);

  return /*#__PURE__*/_jsx(StyledTab, _objectSpread({}, restProps));
});
Tab.displayName = 'Tab';
export { Tab };